import React, { useContext } from 'react';
import { useLocalStorage } from 'utils/useLocalStorage';

import FleetFiltersContext from 'modules/fleet/filters/context';

const DispatchingFiltersContext = React.createContext();

const dispatchingDefaultFilters = {
  need_manual_dispatching: true,
};

function DispatchingFiltersContextProvider({
  defaultFilters = dispatchingDefaultFilters,
  children,
}) {
  const { filters: fleetFilters } = useContext(FleetFiltersContext);
  const [filters, setFilters] = useLocalStorage('dispatching/filters', defaultFilters);

  const composedFilters = { ...fleetFilters, ...filters };

  const value = {
    filters: composedFilters,
    setFilters,
  };

  return (
    <DispatchingFiltersContext.Provider value={value}>
      {children}
    </DispatchingFiltersContext.Provider>
  );
}

const useFiltersHook = () => {
  const { filters, setFilters } = useContext(DispatchingFiltersContext);

  return { filters, setFilters };
};

export default DispatchingFiltersContext;
export { dispatchingDefaultFilters, useFiltersHook, DispatchingFiltersContextProvider };
